module.exports = __webpack_public_path__ + "static/assets/2a629ef316c3be6123ea740947b09e13.png";